/**
 * @param {unknown} error
 * @param {string} [fallback]
 */
export function formatCohorteCapacityError(error, fallback = 'Inscription impossible.') {
  if (!(error instanceof Error)) return fallback;
  const e = /** @type {Error & { code?: string; data?: { alternatives?: Array<{ code?: string; libelle?: string; placesRestantes?: number }> } } } */ (
    error
  );
  if (e.code !== 'COHORTE_COMPLETE') return e.message || fallback;

  const lines = [e.message || 'Cette cohorte (créneau) est complète.'];
  const alts = e.data?.alternatives ?? [];
  if (alts.length > 0) {
    lines.push('');
    lines.push('Autres cohortes ouvertes :');
    for (const a of alts.slice(0, 6)) {
      const label = a.libelle || a.code || 'Cohorte';
      lines.push(`• ${label} — ${a.placesRestantes ?? '?'} place(s) restante(s)`);
    }
  } else {
    lines.push('Consultez une autre filière ou contactez l’administration.');
  }
  return lines.join('\n');
}

/** @param {{ capacity?: { placesRestantes?: number; estComplete?: boolean } } | null | undefined} c */
export function isCohorteFull(c) {
  const cap = c?.capacity;
  if (!cap) return false;
  if (cap.estComplete === true) return true;
  return (cap.placesRestantes ?? 1) <= 0;
}
